import * as React from "react";
import "./Loader.css"

// @ts-ignore
import loader from "../../assets/animated/loader.gif";
import LottieAnimation from "../LottieAnimation/LottieAnimation";


interface IProps {}

export default class Loader  extends React.Component<
    IProps
    > {
    public render() {
        return (
            <div className="loader-container">
                <LottieAnimation animationName={"loader"} loop={true}/>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Loader/Loader.tsx